import _asyncToGenerator from "@babel/runtime-corejs3/helpers/asyncToGenerator";
import _slicedToArray from "@babel/runtime-corejs3/helpers/slicedToArray";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _regeneratorRuntime from "@babel/runtime-corejs3/regenerator";
import _JSON$stringify from "@babel/runtime-corejs3/core-js-stable/json/stringify";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.promise.js";
import { makeStyles, RaiseColors, Typography, useTheme, useMediaQuery } from "componentLibrary";
import RaiseButton, { ButtonVariantEnum, ButtonSizeEnum } from "componentLibrary/MuiComponentWrappers/Button/RaiseButton";
import React from "react";
import * as Yup from "yup";
import LoginFormContentContainer from "./LoginFormContentContainer";
import { Link } from "react-router";
import Cookies from "js-cookie";
import { WorkplaceOSLoginContainer, WorkplaceOSLoginHeader, WorkplaceOSLoginTerms } from "./WorkplaceOSLoginCommon";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
var useStyles = function useStyles() {
  var theme = useTheme();
  return makeStyles(function () {
    return {
      container: _defineProperty(_defineProperty(_defineProperty({
        height: "100%",
        width: "100%"
      }, theme.breakpoints.up("md"), {
        display: "flex"
      }), theme.breakpoints.down("md"), {
        paddingTop: 32,
        display: "block"
      }), "backgroundColor", RaiseColors.neutral200),
      loginContentContainer: _defineProperty({
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        backgroundColor: RaiseColors.neutral200,
        margin: "auto"
      }, theme.breakpoints.up("md"), {
        width: "60%"
      }),
      loginContentImage: _defineProperty(_defineProperty({
        height: 48,
        width: 268
      }, theme.breakpoints.down("smMd"), {
        width: 178,
        height: 32
      }), "marginBottom", 32),
      stockImage: {
        height: "100%",
        width: "40%",
        objectFit: "cover",
        backgroundColor: RaiseColors.midnight
      }
    };
  });
};
var DEFAULT_ERROR_MESSAGE = "Oops ... Seems like there's an error. Please check for typos and try again.";
var EXPIRED_LINK_MESSAGE = /*#__PURE__*/_jsx(_Fragment, {
  children: /*#__PURE__*/_jsxs(Typography, {
    variant: "paragraph_medium",
    children: ["The link has expired and is no longer available. Please", " ", /*#__PURE__*/_jsx(Link, {
      to: "/forgot_password",
      children: "reset your password again"
    }), "."]
  })
});
var WorkplaceResetPassword = function WorkplaceResetPassword(_ref) {
  var params = _ref.params;
  var classes = useStyles()();
  var theme = useTheme();
  var isMobile = useMediaQuery(theme.breakpoints.down("md"));
  var _React$useState = React.useState(false),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    loading = _React$useState2[0],
    setLoading = _React$useState2[1];
  var _React$useState3 = React.useState(false),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    resetSuccessful = _React$useState4[0],
    setResetSuccessful = _React$useState4[1];
  var _React$useState5 = React.useState(false),
    _React$useState6 = _slicedToArray(_React$useState5, 2),
    isError = _React$useState6[0],
    setIsError = _React$useState6[1];
  var _React$useState7 = React.useState(DEFAULT_ERROR_MESSAGE),
    _React$useState8 = _slicedToArray(_React$useState7, 2),
    errorMessage = _React$useState8[0],
    setErrorMessage = _React$useState8[1];
  var ValidationSchema = Yup.object().shape({
    newPassword: Yup.string().nullable().min(8, "Password Length must be at least 8 characters."),
    confirmPassword: Yup.string().nullable().oneOf([Yup.ref("newPassword")], "Passwords did not match, please try again."),
    userEmail: Yup.string().email("Please enter a valid email.").nullable()
  });
  var handleSubmit = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref2) {
      var newPassword, confirmPassword, userEmail, postData, response, data, _t;
      return _regeneratorRuntime.wrap(function (_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            newPassword = _ref2.newPassword, confirmPassword = _ref2.confirmPassword, userEmail = _ref2.userEmail;
            postData = {
              new_password: newPassword,
              confirm_password: confirmPassword,
              reset_code: params.reset_code,
              user_id: params.user_id,
              email: userEmail
            };
            setLoading(true);
            _context.prev = 1;
            _context.next = 2;
            return fetch("/ajax/accounts/reset_password", {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                "X-CSRFToken": Cookies.get("csrftoken") || ""
              },
              body: _JSON$stringify(postData)
            });
          case 2:
            response = _context.sent;
            _context.next = 3;
            return response.json();
          case 3:
            data = _context.sent;
            if (response.ok && data.successful) {
              setResetSuccessful(true);
              setLoading(false);
            } else {
              setLoading(false);
              setIsError(true);
              if (data.currentState === "3") {
                setErrorMessage(EXPIRED_LINK_MESSAGE);
              } else {
                setErrorMessage(data.message || DEFAULT_ERROR_MESSAGE);
              }
            }
            _context.next = 5;
            break;
          case 4:
            _context.prev = 4;
            _t = _context["catch"](1);
            setLoading(false);
            setIsError(true);
            setErrorMessage(DEFAULT_ERROR_MESSAGE);
          case 5:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[1, 4]]);
    }));
    return function handleSubmit(_x) {
      return _ref3.apply(this, arguments);
    };
  }();
  var formElements = [{
    id: "newPassword",
    initialValue: "",
    label: "Password",
    placeholder: "8 characters minimum",
    type: "password"
  }, {
    id: "confirmPassword",
    initialValue: "",
    label: "Password",
    placeholder: "8 characters minimum",
    type: "password"
  }];
  var ResetPasswordSuccessView = function ResetPasswordSuccessView() {
    return /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsxs(WorkplaceOSLoginContainer, {
        children: [/*#__PURE__*/_jsx(WorkplaceOSLoginHeader, {
          title: "Reset Password",
          subHeader: "Congratulations, your password has been reset"
        }), /*#__PURE__*/_jsx(RaiseButton, {
          variant: ButtonVariantEnum.primary,
          size: isMobile ? ButtonSizeEnum.medium : ButtonSizeEnum.large,
          onClick: function onClick() {
            window.location.href = "/raise_login/:next";
          },
          setToFill: true,
          children: "Return to sign in"
        })]
      }), /*#__PURE__*/_jsx(WorkplaceOSLoginTerms, {})]
    });
  };
  return /*#__PURE__*/_jsx(_Fragment, {
    children: /*#__PURE__*/_jsxs("div", {
      className: classes.container,
      children: [/*#__PURE__*/_jsxs("div", {
        className: classes.loginContentContainer,
        children: [/*#__PURE__*/_jsx("img", {
          src: "".concat(window.STATIC_URL, "images/logos/JLL/JLL Leasing OS Logo.svg"),
          className: classes.loginContentImage
        }), resetSuccessful ? /*#__PURE__*/_jsx(ResetPasswordSuccessView, {}) : /*#__PURE__*/_jsx(LoginFormContentContainer, {
          header: "Recover Password",
          formElements: formElements,
          ValidationSchema: ValidationSchema,
          handleSubmit: handleSubmit,
          loading: loading,
          isError: isError,
          errorMessage: typeof errorMessage === "string" ? errorMessage : DEFAULT_ERROR_MESSAGE,
          buttonText: "Reset"
        })]
      }), !isMobile ? /*#__PURE__*/_jsx("img", {
        className: classes.stockImage,
        src: "".concat(window.STATIC_URL, "images/JLL Login Workspace Cover.jpg")
      }) : null]
    })
  });
};
export default WorkplaceResetPassword;